import React from 'react';
import {useSHCore} from '@hooks/useSHCore';
import {getInitialComponentData} from "@helpers/HelperInitialPageState";

const ContextTaxonomy = React.createContext({});


/**
 * @function ContextTaxonomyProvider
 * @property {{taxonomies:Object<TaxonomyData>}} contextData
 * @property {Function} getForIds За дадени service ID-та връща taxonomy-ии
 * @property {Function} getForId За даденo service ID връща съответната taxonomy-я
 *
 */
const ContextTaxonomyProvider = ({children}) => {

	const providerData = getInitialComponentData('contextTaxonomyProvider');

	/**
	 * За дадени service ID-та връща съответните taxonomy-ии
	 * @param {Array<string>} serviceIds
	 * @returns {Object<TaxonomyData>}
	 */
	const getForIds = (serviceIds) => {
		if (serviceIds.length === 0) {
			return {};
		}

		let data = {};
		serviceIds.map((serviceId) => {
			data = {...data, [serviceId]: core.state.contextData.taxonomies[serviceId]}
		});

		return data;
	};

	/**
	 * За даденo service ID връща съответната taxonomy-я
	 * @param {string} serviceId
	 * @returns {Object<TaxonomyData>}
	 */
	const getForId = (serviceId) => {
		return {...core.state.contextData.taxonomies[serviceId]};
	};

	const core = useSHCore({
		name: providerData.componentName,
		token: providerData.componentToken,
		initialState: {
			contextData: providerData.componentData,
			getForId,
			getForIds,
		},
	});

	return (
	  <ContextTaxonomy.Provider value={core.state}>
		  {children}
	  </ContextTaxonomy.Provider>
	);
};

export {ContextTaxonomy, ContextTaxonomyProvider};

/**
 * @typedef {Object} TaxonomyData
 * @property {string} id - идентификатор на taxonomy-ята.
 * @property {string} brand - Бранд.
 * @property {boolean} canNew - Дали да се репортва към Google при нова поръчка
 * @property {boolean} canRenew - Дали да се репортва към Google при подновяване
 * @property {boolean} canTransfer - pДали да се репортва към Google при трансфер
 * @property {string} category - Категория в Google.
 * @property {string} name - Име в Google
 * @property {boolean} reportToAnalytics - Дали да се репортува до аналитикс
 * @property {string} serviceId - id на услугата
 */
